
export { ShoppingBagButton } from "/codebuild/output/src1227593752/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"